import common from "./common";
import SplashScene from "./scenes/SplashScene";
import GameScene from "./scenes/GameScene";
import DrawingScene from "./scenes/DrawingScene";
import SaveData from "./SaveData";
import TestScene from "./scenes/TestScene";
import SplineEditorScene from "./scenes/SplineEditorScene";
import ResultsScene from "./scenes/ResultsScene";

export default class Application {
    constructor() {

    }

    init() {

        common.saveData = new SaveData();
        common.saveData.load();

        //this.showGameScene();
        this.showSplashScene();
        //  this.showGameScene();

        // this.showSplineEditorScene();
      //  this.showDrawingScene();
        //   this.showResultsScene();

    }

    showSplashScene() {
        //.tracking.track(new P3.tracking.TrackingDataGTagEvent("play"));
        P3.audio.playMusic("music_garage_drawing_loop_00");
        const scene = new SplashScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showDrawingScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showDrawingScene() {
        //.tracking.track(new P3.tracking.TrackingDataGTagEvent("play"));

        const scene = new DrawingScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showGameScene();
        }, this);

        scene.signals.home.add(function () {
            this.showSplashScene();
        }, this);

        scene.signals.previous.add(function () {
            this.showDrawingScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showGameScene() {
        //.tracking.track(new P3.tracking.TrackingDataGTagEvent("play"));
        P3.audio.stopMusic();

        const scene = new GameScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showResultsScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showResultsScene() {

        P3.audio.playMusic("music_menu_loop_00");

        const scene = new ResultsScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            P3.audio.playMusic("music_garage_drawing_loop_00");
            this.showDrawingScene();
        }, this);

        scene.signals.previous.add(function () {
            P3.audio.stopMusic();
            this.showGameScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showTestScene() {
        //.tracking.track(new P3.tracking.TrackingDataGTagEvent("play"));

        const scene = new TestScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            //  this.showDrawingScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showSplineEditorScene() {
        //.tracking.track(new P3.tracking.TrackingDataGTagEvent("play"));

        const scene = new SplineEditorScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            //  this.showDrawingScene();
        }, this);

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    fadeTransition(a, b, scope) {
        scope = scope || window;

        const transition = new P3.FadeTransition(0x0);
        common.transitions.addChild(transition);

        transition.signals.in.add(function () {
            transition.out();
            a && a.call(scope);
        }, this);

        transition.signals.out.add(function () {
            transition.destroy();
            b && b.call(scope);
        }, this);

        transition.in();
    }
}